import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { SecurityService } from "./security.service";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseUrl = `${environment.apiUrl}/person`;
  private baseUrl2 = `${environment.apiUrlV2}/person`;
  private baseUrl3 = `${environment.apiUrl}/companyPerson`;
  private baseUrl4 = `${environment.apiAuth}/account`;
  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private security: SecurityService,
    private http: HttpClient
  ) { }

  getAll(id) {
    return this.http
      .get<any>(this.baseUrl3 + '/company/' + id, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getTemplate(id) {
    return this.http
      .get<any>(this.baseUrl3 + '/templateSheet/' + id, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getCPF(value) {
    return this.http
      .get<any>(this.baseUrl2 + '/document/' + value, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {

        })
      ).toPromise();
  }

  getByIdPerson(value) {
    return this.http
      .get<any>(this.baseUrl2 + '/' + value, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {

        })
      ).toPromise();
  }

  getByIdPersonCompany(value) {
    return this.http
      .get<any>(this.baseUrl + '/' + value, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {

        })
      ).toPromise();
  }

  add(body) {
    return this.http
      .post<any>(this.baseUrl + '/create', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  post(body) {
    return this.http
      .post<any>(this.baseUrl2 + '/PersonCreate', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  postCompanyPerson(body) {
    return this.http
      .post<any>(this.baseUrl2 + '/companyPerson', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  edit(body) {
    return this.http
      .patch<any>(this.baseUrl + '/' + body.id, body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  editPerson(body, company, data) {
    return this.http
      .put<any>(this.baseUrl + '/' + data.personId + '/company/' + company, body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  editPersonId(id, data) {
    return this.http
      .put<any>(this.baseUrl2 + '/' + id, data, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  changePassword(body) {
    let header = new HttpHeaders({
      'Authorization': 'Bearer ' + window.localStorage.getItem('cp_tkn_x'),
      'Accept': '*'
    })

    return this.http
      .post<any>(this.baseUrl4 + '/changePassword', body, { headers: header, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  getProviders() {
    return this.http
      .get<any>(this.baseUrl + '/ListActiveProviders', { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getEmails(document) {

    let encriptado = { ForgetInfo: this.security.letScriptData(document) };
    console.log(encriptado)

    return this.http
      .post(this.baseUrl2 + '/document/emails', encriptado, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getProvidersById(id) {
    return this.http
      .get<any>(this.baseUrl + '/InsuranceCompanyById/' + id, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getBranchesById(id) {
    return this.http
      .get<any>(this.baseUrl2 + '/GetBranchesCompanyById/' + id, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  deleteCompany(id) {
    return this.http
      .delete<any>(this.baseUrl + '/' + id, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getById(id) {
    return this.http
      .get<any>(this.baseUrl + '/CompanyById/' + id, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  peopleCreate(people: any[]) {
    return this.http
      .post<any>(this.baseUrl2 + '/PeopleCreate', people, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  setPermission(id, companyId, body) {
    return this.http
      .put<any>(this.baseUrl + '/' + id + '/company/' + companyId, body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }
}
